import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	max-width: 1420px;
	margin: 0 auto;

	&.dark {
		h2 {
			color: ${CSSVars.white};
		}
	}

	h2 {
		margin: 0 auto;
		text-align: center;
		font-size: ${CSSVars.fontSize2XL};
		color: ${CSSVars.gray900};
		font-weight: 600;
		margin-bottom: 50px;
		max-width: 565px;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSize4XL};
		}
	}
`;
